import React, { useEffect, useState } from 'react';
import { components } from '../components';
import { useLocation } from 'react-router-dom';
import { callService } from '../customHook/callService';
import { text } from '../text';
import { theme } from '../constants';

export const OurServices: React.FC = () => {
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [selectedLoan, setSelectedLoan] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, [pathname]);

    const services = [
        {
            title: 'PURCHASE LEADS OF TENANTS',
            description: 'Get verified rental leads of tenants actively looking for properties.',
            image: require('../assets/other/leads.png'),
        },
        {
            title: 'PROPERTY MANAGEMENT APP',
            description: 'Track rent, complaints, and property data all in one place.',
            image: require('../assets/other/propertyManage.png'),

        },
        {
            title: 'LOANS',
            description: 'Flexible loans for tenants, owners, and operators.',
            image: require('../assets/other/loan.png'),

        },
        {
            title: 'ELECTRICITY PREPAID METER',
            description: 'Prepaid electricity meters for transparency and savings.',
            image: require('../assets/other/electricityMeter.png'),

        },
    ];



    // HANDLE THE LEAD API BANNER

    const handleCallBack = async (title: string) => {
        try {
            const res = await callService('Banner', [
                {
                    param: 'Banner',
                    value: title,
                },
            ]);
            setSelectedLoan(title);
            setIsModalOpen(true);
            console.log(`✅ CLICK_BANNER triggered for "${title}"`, res);
        } catch (error) {
            setSelectedLoan(title);
            setIsModalOpen2(true);
            console.error(`❌ CLICK_BANNER failed for "${title}"`, error);
        }
    };



    return (
        <>
            <components.Header title="Our Services" goBack={true} />
            <main className="container">
                <div style={{ marginTop: '10%', marginBottom: 40 }}>
                    <h2
                        style={{
                            textAlign: 'center',
                            marginBottom: '10px',
                            fontSize: '24px',
                            fontWeight: '600',
                            color: '#2C2C2C',
                        }}
                    >
                        Discover Our Services
                    </h2>
                    <p
                        style={{
                            textAlign: 'center',
                            marginBottom: '18px',
                            fontSize: '16px',
                            color: '#6c6c6c',
                            lineHeight: '1.9',

                        }}
                    >
                        Solutions designed to support property owners and tenants alike.
                    </p>

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: '24px',
                        }}
                    >
                        {services.map((service, index) => (
                            <div
                                key={index}
                                style={{
                                    border: '1px solid #eee',
                                    borderRadius: '10px',
                                    padding: '20px 20px',
                                    textAlign: 'center',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                                    transition: 'transform 0.2s',
                                }}
                            >
                                <div
                                    style={{
                                        width: '200px',
                                        height: 'auto',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '0 auto', // centers the container itself
                                    }}
                                >
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                        }}
                                    />
                                </div>

                                <h3 style={{ fontSize: '18px', marginBottom: '8px', marginTop: "15px", fontWeight: "600", color: "#7065F0" }}>{service.title}</h3>
                                <p style={{ fontSize: '14px', color: '#666', margin: '22px 0px' }}>
                                    {service.description}
                                </p>
                                <button
                                    onClick={() => handleCallBack(service.title)}
                                    style={{
                                        padding: '10px 35px',
                                        backgroundColor: '#7065F0',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '18px',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        marginBottom: "5px"
                                    }}
                                >
                                    {/* Request a Call Back */}
                                    I'm Interested
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                {isModalOpen && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <img
                                    alt='Success'
                                    src={require('../assets/other/04.png')}
                                    style={{ width: '50%', height: 'auto', marginBottom: 10 }}
                                />
                                {/* <span
                                                                                    style={{
                                                                                        ...theme.fonts.LeagueSpartan_500Medium,
                                                                                        fontSize: 12,
                                                                                        color: theme.colors.mainColor,
                                                                                    }}
                                                                                >
                                                                                    Nuton
                                                                                </span> */}
                                <img
                                    alt='Success'
                                    // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                                    src={require('../assets/other/check.png')}
                                    style={{ width: '30%', height: 'auto', margin: "30px 0" }}
                                />
                                <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
                                    ✅ Request Sent Successfully
                                </h2>
                                <p style={{ textAlign: 'center', marginBottom: 10, lineHeight: "1.6" }}>
                                    Interest Registered for: <div>{selectedLoan}</div>
                                </p>
                                <text.T14
                                    style={{
                                        whiteSpace: 'pre-line',
                                        textAlign: 'center',
                                        marginBottom: 24,
                                    }}
                                >
                                    Thank you! Our team will contact you soon.
                                </text.T14>
                                <div
                                    onClick={() => {
                                        setIsModalOpen(false)
                                    }}
                                    style={{
                                        width: '100%',
                                        color: theme.colors.white,
                                        height: 40,
                                        textAlign: 'center',
                                        fontSize: 14,
                                        borderRadius: 10,
                                        userSelect: 'none',
                                        cursor: 'pointer',
                                        textTransform: 'capitalize',
                                        background: "#000000d1",
                                        fontFamily: 'Lato-Bold',
                                        marginTop: 12, // optional spacing
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    Continue
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {isModalOpen2 && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <img
                                    alt='Success'
                                    src={require('../assets/other/04.png')}
                                    style={{ width: '50%', height: 'auto', marginBottom: 10 }}
                                />
                                {/* <span
                                                                                    style={{
                                                                                        ...theme.fonts.LeagueSpartan_500Medium,
                                                                                        fontSize: 12,
                                                                                        color: theme.colors.mainColor,
                                                                                    }}
                                                                                >
                                                                                    Nuton
                                                                                </span> */}
                                <img
                                    alt='Success'
                                    // src='https://george-fx.github.io/nuton_api/assets/images/08.png'
                                    src={require('../assets/other/warning.png')}
                                    style={{ width: '25%', height: 'auto', margin: "30px 0" }}
                                />
                                <h2 style={{ textAlign: 'center', marginBottom: 10 }}>
                                    Something Went Wrong
                                </h2>
                                <p style={{ textAlign: 'center', marginBottom: 10, lineHeight: "1.6" }}>
                                    We couldn't process your request.
                                </p>
                                <text.T14
                                    style={{
                                        whiteSpace: 'pre-line',
                                        textAlign: 'center',
                                        marginBottom: 24,
                                    }}
                                >
                                    Please try again later. If the issue persists, contact our support team.
                                </text.T14>
                                <div
                                    onClick={() => {
                                        setIsModalOpen2(false)
                                    }}
                                    style={{
                                        width: '100%',
                                        color: theme.colors.white,
                                        height: 40,
                                        textAlign: 'center',
                                        fontSize: 14,
                                        borderRadius: 10,
                                        userSelect: 'none',
                                        cursor: 'pointer',
                                        textTransform: 'capitalize',
                                        background: "#000000d1",
                                        fontFamily: 'Lato-Bold',
                                        marginTop: 12, // optional spacing
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    Continue
                                </div>
                            </div>
                            {/* <div className="modal-buttons">
                                                                <button
                                                                    type="button"
                                                                    className="cancel-button"
                                                                    onClick={() => setIsModalOpen2(false)}
                                                                >
                                                                    Thank You
                                                                </button>
                                
                                                            </div> */}
                        </div>
                    </div>
                )}
            </main>
        </>
    );
};
